/*
このファイルはwavify.jsをgsap3に対応させ、初回実行時のdurationの調整（バグ調整）をしています。
*/
function wavify(wave_element, options) {
  if ("undefined" === typeof options) options = {};

  //  Options
  var settings = Object.assign(
    {},
    {
      container: options.container ? options.container : "body",
      height: 200,
      amplitude: 100,
      speed: 0.15,
      bones: 3,
      color: "rgba(255,255,255, 0.20)"
    },
    options
  );

  var wave = wave_element,
    width = wave.closest(settings.container).getBoundingClientRect().width,
    height = wave.closest(settings.container).getBoundingClientRect().height,
    points = [],
    lastUpdate,
    totalTime = 0,  // 初期化
    animationInstance = false,
    gsapInstance = false;

  function drawPoints(factor) {
    var points = [];

    for (var i = 0; i <= settings.bones; i++) {
      var x = (i / settings.bones) * width;
      var sinSeed = (factor + (i + (i % settings.bones))) * settings.speed * 100;
      var sinHeight = Math.sin(sinSeed / 100) * settings.amplitude;
      var yPos = Math.sin(sinSeed / 100) * sinHeight + settings.height;
      points.push({ x: x, y: yPos });
    }

    return points;
  }

  function drawPath(points) {
    var SVGString = "M " + points[0].x + " " + points[0].y;

    var cp0 = {
      x: (points[1].x - points[0].x) / 2,
      y: points[1].y - points[0].y + points[0].y + (points[1].y - points[0].y)
    };

    SVGString +=
      " C " +
      cp0.x +
      " " +
      cp0.y +
      " " +
      cp0.x +
      " " +
      cp0.y +
      " " +
      points[1].x +
      " " +
      points[1].y;

    var prevCp = cp0;
    var inverted = -1;

    for (var i = 1; i < points.length - 1; i++) {
      var cp1 = {
        x: points[i].x - prevCp.x + points[i].x,
        y: points[i].y - prevCp.y + points[i].y
      };

      SVGString +=
        " C " +
        cp1.x +
        " " +
        cp1.y +
        " " +
        cp1.x +
        " " +
        cp1.y +
        " " +
        points[i + 1].x +
        " " +
        points[i + 1].y;
      prevCp = cp1;
      inverted = -inverted;
    }

    SVGString += " L " + width + " " + height;
    SVGString += " L 0 " + height + " Z";
    return SVGString;
  }

  // 最初のdrawで波が完全に表示されるように
  var isFirstDraw = true;  // 初回かどうかを判断するフラグ

  function draw() {
    var now = window.Date.now();

    if (lastUpdate) {
      var elapsed = (now - lastUpdate) / 1000;
      lastUpdate = now;

      totalTime += elapsed;
      var factor = totalTime * Math.PI;

      gsapInstance = gsap.to(wave, {
        duration: isFirstDraw ? 0 : settings.speed,  // 初回のみdurationを0に
        attr: {
          d: drawPath(drawPoints(factor))
        },
        ease: "none"
      });

      // 初回描画が終わったらフラグをfalseに設定
      if (isFirstDraw) {
        isFirstDraw = false;
      }
    } else {
      lastUpdate = now;
    }

    // 次のフレームで再度呼び出される
    animationInstance = requestAnimationFrame(draw);
  }


  // 初期設定のスケールを1に固定
  function boot() {
    if (!animationInstance) {
      gsap.set(wave, { attr: { fill: settings.color }, scale: 1 });  // スケール1で固定
      play();
      window.addEventListener("resize", redraw);
    }
  }

  function play() {
    if (!animationInstance) {
      animationInstance = requestAnimationFrame(draw);
    }
  }

  function pause() {
    if (animationInstance) {
      cancelAnimationFrame(animationInstance);
      animationInstance = false;
    }
  }

  function redraw() {
    pause();
    width = wave.closest(settings.container).getBoundingClientRect().width;
    height = wave.closest(settings.container).getBoundingClientRect().height;
    lastUpdate = false;
    play();
  }

  window.addEventListener("resize", redraw);
  boot();
}
